import { EChartsOption } from 'echarts/types/dist/shared';

export const turnoverChartOptions: EChartsOption = {
  series: [
    {
      axisLabel: {
        color: '#333',
        distance: -30,
        fontSize: 12,
        fontWeight: 'normal',
        formatter: (value) => {
          if (value >= 6 && value < 8) {
            return 'High';
          } else if (value >= 4 && value < 6) {
            return 'Medium';
          } else if (value > 0 && value < 4) {
            return 'Low';
          }
          return '';
        },
        rotate: 'tangential'
      },
      axisLine: {
        lineStyle: {
          color: [
            [0.25, '#1677ff'],
            [0.75, '#fa8c16'],
            [1, '#cf1322']
          ],
          width: 4
        }
      },
      axisTick: {
        distance: 2,
        length: 3,
        lineStyle: {
          color: 'auto',
          width: 1
        }
      },
      center: ['50%', '70%'],
      data: [
        {
          name: 'Annual Turnover:',
          value: 0
        }
      ],
      detail: {
        color: '#333',
        fontSize: 12,
        formatter: (value) => {
          return value.toFixed(2) + '%';
        },
        offsetCenter: [0, 0],
        valueAnimation: true
      },
      endAngle: 0,
      max: 8,
      min: 0,
      pointer: {
        icon: 'rect',
        itemStyle: {
          color: 'auto'
        },
        length: '50%',
        offsetCenter: [0, -20],
        width: 2
      },
      radius: '90%',
      splitLine: {
        distance: 2,
        length: 8,
        lineStyle: {
          color: 'auto',
          width: 2
        }
      },
      splitNumber: 4,
      startAngle: 180,
      type: 'gauge'
    }
  ],
  title: {
    bottom: '5%',
    text: 'Annual Turnover',
    textStyle: {
      fontSize: 12,
      fontWeight: 'bold'
    }
  }
};
